import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NavLink, Link} from 'react-router-dom';
import './SideBar.css';
//import logo from '../../../img/logo.svg';
import logoMobile from '../../../img/logo-mobile.svg';
import * as routes from '../../../constants/routes';
import utility from "../../../utility/utility";

class SideBar extends Component {
    render() {
        const {pagesData, name, bodyType} = this.props;

        let linksForPages = pagesData.map((item, i) => {
            return (
                <NavLink 
                    to={`/report/${item.link}`} 
                    key={i} 
                    className="side-bar__page-link"
                    activeClassName="side-bar__page-link_active"
                    >
                        {item.name}
                </NavLink>
            )
        });

        return (
            <div className="side-bar">
                <div className="side-bar__fixed-area">

                    <Link to={routes.REPORT} className="side-bar__logo">
                        <img className="report-header__logo" src={logoMobile} alt="logo"/>
                    </Link>

                    <div className="side-bar__user-block">
                        <div className="side-bar__user-type">{utility.bodyTypeLetter(bodyType)}</div>
                        <p className="side-bar__user-name">{name}</p>
                    </div>

                    <div className="side-bar__pages-area">
                        <div className="side-bar__pages-list">
                             {linksForPages}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

SideBar.propTypes = {
    pagesData: PropTypes.arrayOf(PropTypes.shape({
        link: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      })).isRequired
};

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/Report/SideBar/SideBar.js